import { useState } from "react";
import { noRecordsAlert } from "../../../../../../_helpers/Helpers";
import { TeacherUsersUIProvider } from "./TeacherUsersUIContext";
import { TeacherUsersCard } from "./TeacherUsersCard";
import { IPListEdit } from "../IP-list-edit/IPListEdit";

export function TeacherUsersPage() {
  const [ids, setIds] = useState();
  const [showIPListEdit, setShowIPListEdit] = useState();
  const closeIPListEdit = () => setShowIPListEdit(false);
  
  const teacherUsersUIEvents = {
    openIPListEditModal: (ids) => {
      if (typeof ids === 'string') ids = ids.split(",");
            
      if (ids.length < 1) {
        noRecordsAlert();
        return;
      }
      setIds(ids);
      setShowIPListEdit(true);
    }
  };

  return (
    <TeacherUsersUIProvider teacherUsersUIEvents={teacherUsersUIEvents}>
      <IPListEdit
        ids={ids}
        showIPListEdit={showIPListEdit}
        closeIPListEdit={closeIPListEdit}
      />
      <TeacherUsersCard />
    </TeacherUsersUIProvider>
 );
}